<template>
  <div class="d-inline-flex">
    <document-component
      v-if="documents.length > 0"
      :documents="documents"
      :newsFeedData="newsFeedData"
    ></document-component>
    <v-speed-dial
      v-model="shareNewsFeed"
      direction="bottom"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
          <template v-slot:activator="{ on: tooltip, attrs }">
            <v-icon
              v-model="shareNewsFeed"
              v-if="shareNewsFeed"
              class="mr-2 vuetify-icon"
              color="#344452"
              v-bind="attrs"
              v-on="{ ...tooltip }"
              >mdi-close</v-icon
            >
            <v-icon
              v-else
              v-model="shareNewsFeed"
              class="mr-2 vuetify-icon"
              color="#344452"
              v-bind="attrs"
              v-on="{ ...tooltip }"
              >mdi-share-variant</v-icon
            >
          </template>
          <span>Share</span>
        </v-tooltip>
      </template>
      <vue-goodshare-facebook
        :page_url="baseUrl + newsFeedData._id"
        has_icon
      ></vue-goodshare-facebook>
      <vue-goodshare-twitter
        :page_url="baseUrl + newsFeedData._id"
        has_icon
      ></vue-goodshare-twitter>
      <vue-goodshare-linkedin
        :page_url="baseUrl + newsFeedData._id"
        has_icon
      ></vue-goodshare-linkedin>
    </v-speed-dial>
  </div>
</template>
<script>
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareLinkedin from "vue-goodshare/src/providers/LinkedIn.vue";

export default {
  name: "NewFeedAction",
  components: {
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareLinkedin,
    DocumentComponent: () => import("@/components/Documents")
  },
  props: {
    newsFeedData: Object
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_SERVERURL + "newsfeed/view/",
      dialog2: false,
      shareNewsFeed: false
    };
  },
  computed: {
    documents() {
      return this.newsFeedData.media.filter(media => media.mediaType == "doc");
    }
  }
};
</script>

<style scoped lang="scss">
.v-list-item {
  .list-item {
    cursor: pointer;
    font-family: "Palanquin", sans-serif;
    font-style: normal;
    font-size: 15px;
    line-height: 130%;
    color: #313131;
    letter-spacing: 0.05em;
  }
  min-height: 32px;
}
</style>
